// extracted by mini-css-extract-plugin
export default {"todo":"TodoPage_todo__6BW3r","active":"TodoPage_active__Es3I5"};